import { render } from "./CurrentModal.vue?vue&type=template&id=ed01ef58"
import script from "./CurrentModal.vue?vue&type=script&lang=js"
export * from "./CurrentModal.vue?vue&type=script&lang=js"

import "./CurrentModal.vue?vue&type=style&index=0&id=ed01ef58&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__